import { render, staticRenderFns } from "./ListUserPregnanciesData.vue?vue&type=template&id=42a2b75e&"
import script from "./ListUserPregnanciesData.vue?vue&type=script&lang=js&"
export * from "./ListUserPregnanciesData.vue?vue&type=script&lang=js&"
import style0 from "./ListUserPregnanciesData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports